import { NgModule } from '@angular/core'
import { DisplayMultipleNamesShortPipe } from './display-multiple-names-short.pipe'

@NgModule({
    declarations: [DisplayMultipleNamesShortPipe],
    exports: [DisplayMultipleNamesShortPipe],
    providers: [DisplayMultipleNamesShortPipe],
})
export class DisplayMultipleNamesShortModule {
}